import * as React from 'react';
import { forwardRef, PropsWithChildren } from 'react';
import { colors } from '@material-ui/core';

// MATERIAL TABLE ICONS
import { Icons } from 'material-table';
import AddBox from '@material-ui/icons/Add';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Cancel';
import SaveAlt from '@material-ui/icons/Save';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

type IconProps = PropsWithChildren<{ disabled?: boolean }>;

const TableIcons: Icons = {
  Add: forwardRef<SVGSVGElement>((props, ref) => (
    <AddBox {...props} style={{ color: colors.common.white }} ref={() => ref} />
  )),
  Check: forwardRef<SVGSVGElement>((props: IconProps, ref) => (
    <Check {...props} color={props.disabled ? 'disabled' : 'primary'} ref={() => ref} />
  )),
  Clear: forwardRef<SVGSVGElement>((props, ref) => (
    <Clear {...props} style={{ color: colors.red.A200 }} ref={() => ref} />
  )),
  Delete: forwardRef<SVGSVGElement>((props, ref) => (
    <DeleteOutline {...props} style={{ color: colors.red.A200 }} ref={() => ref} />
  )),
  DetailPanel: forwardRef<SVGSVGElement>((props, ref) => (
    <ChevronRight {...props} ref={() => ref} />
  )),
  Edit: forwardRef<SVGSVGElement>((props: IconProps, ref) => (
    <Edit {...props} color={props.disabled ? 'disabled' : 'primary'} ref={() => ref} />
  )),
  Export: forwardRef<SVGSVGElement>((props, ref) => <SaveAlt {...props} ref={() => ref} />),
  Filter: forwardRef<SVGSVGElement>((props, ref) => <FilterList {...props} ref={() => ref} />),
  FirstPage: forwardRef<SVGSVGElement>((props, ref) => <FirstPage {...props} ref={() => ref} />),
  LastPage: forwardRef<SVGSVGElement>((props, ref) => <LastPage {...props} ref={() => ref} />),
  NextPage: forwardRef<SVGSVGElement>((props, ref) => <ChevronRight {...props} ref={() => ref} />),
  PreviousPage: forwardRef<SVGSVGElement>((props, ref) => (
    <ChevronLeft {...props} ref={() => ref} />
  )),
  ResetSearch: forwardRef<SVGSVGElement>((props: IconProps, ref) => (
    <Clear {...props} color={props.disabled ? 'disabled' : 'primary'} ref={() => ref} />
  )),
  Search: forwardRef<SVGSVGElement>((props: IconProps, ref) => (
    <Search {...props} color={props.disabled ? 'disabled' : 'primary'} ref={() => ref} />
  )),
  SortArrow: forwardRef<SVGSVGElement>((props, ref) => <ArrowUpward {...props} ref={() => ref} />),
  ThirdStateCheck: forwardRef<SVGSVGElement>((props, ref) => <Remove {...props} ref={() => ref} />),
  ViewColumn: forwardRef<SVGSVGElement>((props, ref) => <ViewColumn {...props} ref={() => ref} />)
};

export default TableIcons;
